import React from 'react';
import '../styles/MobileQuickActions.css';

const MobileQuickActions = () => {
  return (
    <div className="mobile-quick-actions" aria-label="Quick contact actions">
      <a href="tel:+442038393300" className="mobile-action-btn call" aria-label="Call now">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.62 10.79a15.053 15.053 0 0 0 6.59 6.59l2.2-2.2c0.27-0.27 0.67-0.36 1.02-0.24 1.12 0.37 2.33 0.57 3.57 0.57 0.55 0 1 0.45 1 1V20c0 0.55-0.45 1-1 1C10.85 21 3 13.15 3 3c0-0.55 0.45-1 1-1h3.5c0.55 0 1 0.45 1 1 0 1.24 0.2 2.45 0.57 3.57 0.11 0.35 0.03 0.74-0.25 1.02l-2.2 2.2Z" />
        </svg>
      </a>
      <a href="https://wa.me/447365874733" target="_blank" rel="noopener noreferrer" className="mobile-action-btn whatsapp" aria-label="WhatsApp chat">
        <svg viewBox="0 0 32 32" aria-hidden="true">
          <path d="M16 2.5C8.44 2.5 2.5 8.44 2.5 16c0 2.42.63 4.8 1.82 6.92L2.5 29.5l7.65-2.3C13.13 29.35 15.5 29.5 16 29.5c7.56 0 13.5-5.94 13.5-13.5S23.56 2.5 16 2.5zm0 24c-1.62 0-3.17-.4-4.62-1.15l-.33-.18-3.42 1.02.98-3.55-.2-.33C5.4 19.2 5 17.61 5 16c0-6.06 4.94-11 11-11s11 4.94 11 11-4.94 11-11 11z" />
          <path d="M22.67 19.4c-.33-.17-1.97-.97-2.28-1.08-.31-.1-.54-.16-.77.17-.23.33-.88 1.08-1.08 1.3-.19.23-.39.25-.72.09-.33-.16-1.41-.52-2.68-1.65-.99-.88-1.66-1.97-1.85-2.3-.19-.33-.02-.52.15-.68.15-.15.33-.39.5-.59.16-.19.22-.33.33-.55.11-.22.06-.41-.03-.58-.09-.17-.77-1.85-1.05-2.53-.27-.66-.54-.57-.77-.58h-.66c-.23 0-.61.09-.93.44-.32.35-1.22 1.19-1.22 2.9 0 1.72.96 3.38 1.1 3.62.14.24 1.93 3.6 4.64 5.06.64.34 1.14.55 1.53.71.64.25 1.23.21 1.69.13.52-.08 1.6-.65 1.83-1.28.22-.63.22-1.17.16-1.28-.07-.11-.28-.17-.59-.3z" />
        </svg>
      </a>
    </div>
  );
};

export default MobileQuickActions;
